import React from 'react';

import { Box } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { Button, FullscreenLoader } from 'src/components/common';
import { usePeoStaff } from 'src/hooks/peoStaff';

import { PeoStaffViewDetailsModalHead } from './components/PeoStaffViewDetailsModalHead';

// it's not actually a form, but the name is chosen for consistency

interface PeoStaffViewDetailsModalFormMinimalProps {
  peoStaffId: Nullable<string>;
  handleCloseModal: () => void;
}

export const PeoStaffViewDetailsModalFormMinimal: React.FC<
  PeoStaffViewDetailsModalFormMinimalProps
> = ({ peoStaffId, handleCloseModal }) => {
  const { peoStaff, peoStaffRoleName, loading } = usePeoStaff(peoStaffId);

  if (loading || !peoStaff) {
    return <FullscreenLoader />;
  }

  return (
    <React.Fragment>
      <PeoStaffViewDetailsModalHead peoStaff={peoStaff} peoStaffRoleName={peoStaffRoleName} />

      <Box display="flex" gap={2} mt={4} justifyContent="center">
        <Button variant="outlined" color="error" onClick={handleCloseModal}>
          Close
        </Button>
      </Box>
    </React.Fragment>
  );
};
